import React, { useCallback } from 'react';
import { View } from 'react-native';
import { SettingsItem } from 'design-system';
import { IconFemale } from 'design-system/icons/IconFemale';
import { IconGender } from 'design-system/icons/IconGender';
import { IconMale } from 'design-system/icons/IconMale';
import { TITLES } from '../../monevo/models';
const graphics = {
    Mr: <IconMale />,
    Mrs: <IconFemale />,
    Miss: <IconFemale />,
    Ms: <IconFemale />,
    Dr: <IconGender gradientKey="darkPurple"/>,
    Other: <IconGender gradientKey="darkPurple"/>,
};
const TitleModalContent = ({ onPress, closeModal, titles }) => {
    const titleOptions = titles ?? TITLES;
    const onPressTitle = useCallback((title) => () => {
        onPress(title);
        closeModal();
    }, [closeModal, onPress]);
    return (<View>
      {titleOptions.map((title) => (<SettingsItem key={title.value} title={title.label} onPress={onPressTitle(title)} icon={graphics[title.value]}/>))}
    </View>);
};
export default TitleModalContent;
